module.exports = __webpack_public_path__ + "static/media/tutoring-sax.b8ee03c8.png";